/**
 * Configuration des filtres spéciaux (recherches avancées côté API).
 * Ces filtres ne correspondent pas à une colonne du tableau mais à un
 * paramètre de recherche envoyé directement à l'API.
 *
 * Chaque entrée :
 *   - filterKey            : clé envoyée dans les params API (et stockée dans flotteFiltersAtom)
 *   - title                : libellé affiché dans le dropdown et le badge
 *   - value                : valeur envoyée à l'API lorsque le filtre est activé
 *   - icon                 : icône FontAwesome (optionnel)
 *   - forceVisibleColumns  : clés de columnsConfig à forcer visibles lorsque le filtre est activé (optionnel)
 */
const specialFiltersConfig = [
  {
    filterKey: "anomalie_facturation",
    title: "Anomalie facturation",
    value: true,
    icon: "fa-exclamation-triangle",
  },
  {
    filterKey: "anomalie_depassement_kilometrique",
    title: "Anomalie dépassement kilométrique",
    value: true,
    icon: "fa-tachometer-alt",
    forceVisibleColumns: ["mouvement_simulation_prorata_km_km_sup"],
  },
];

export default specialFiltersConfig;
